import { t } from 'i18next';

import { navigation } from '../../profile/profileTabNavigation/navigation';

export const getSupportUrl = (isPamUser: boolean, region: string) => {
  if (isPamUser) {
    return `${process.env.REACT_APP_HOST}/support/services`;
  }

  return region === 'UK'
    ? 'https://www.mind.org.uk/information-support/types-of-mental-health-problems/mental-health-problems-introduction/useful-contacts'
    : 'https://findahelpline.com';
};

export interface SupportPageItem {
  id: number;
  code: number;
  label: string;
  type: string;
  href: string;
  isActive: boolean;
  isVisible: boolean;
}
export const getSupportPageItems = (hasTags: boolean): SupportPageItem[] => {
  if (hasTags) return [];
  const assessmentItem = navigation.find((item) => item.title === 'assessment');
  if (assessmentItem) {
    return [
      {
        id: assessmentItem.target,
        code: assessmentItem.target,
        label: t(assessmentItem.code),
        type: 'link',
        href: '/assessment',
        isActive: false,
        isVisible: true,
      },
    ];
  }
  return [];
};
